import Button from '../../../../../../designSystem/Button/Button';
import { CreateAccountButtonProps } from './CreateAccountManuallyButton.types';
import { useState } from 'react';
import Modal from '../../../../../../commons/Modal/Modal';
import CreateAccountManuallySteps from '../CreateAccountManuallySteps/CreateAccountManuallySteps';
import { ModalSizes } from '../../../../../../commons/Modal/Modal.types';

export default ({ prospectId, ...props }: CreateAccountButtonProps) => {

  const [isModalOpen, setModalOpen] = useState<boolean>(false)

  return (
   <>
     <Button
        style={{
          alignSelf: 'center',
          marginTop: 'var(--spacing-s)',
        }}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          setModalOpen(true)
        }}
        {...props}
      />
      <Modal 
        isOpen={isModalOpen} 
        setOpen={setModalOpen} 
        size={ModalSizes.Large}
        closeOnClickOutside
      >
        <CreateAccountManuallySteps {...{ prospectId }} />
      </Modal>
   </>
  );
};
